module.exports = "/_next/static/images/case-tracker-581a080579d10d5659da4df55cd1482b.png";